<script lang="ts" setup>
import { fromNow } from '@thecompaniesapi/date-helpers'

const { locale, t } = useI18n()
const { connected, lastEvent, pinging } = useSockets()

const lastEventAgo = computed(() => {
  if (!lastEvent.value) {
    return ''
  }

  return fromNow(lastEvent.value, locale.value)
})
</script>

<template>
  <UPopover
    mode="hover"
    :ui="{ shadow: 'shadow-sm' }"
  >
    <UButton class="rounded-full px-4">
      <div class="flex items-center gap-2 text-sm">
        <span>
          {{ connected?.global ? t('connected') : t('notConnected') }}
        </span>

        <BasePingDot
          :color="connected?.global ? 'green' : 'red'"
          :pinging="pinging"
        />
      </div>
    </UButton>

    <template #panel>
      <div class="gradient-texture flex flex-col items-center gap-1 p-3">
        <span class="text-sm">
          {{ connected?.global ? t('allSocketsConnected') : t('notConnected') }}
        </span>

        <span
          v-if="lastEventAgo"
          class="text-xs"
        >
          {{ t('lastEvent') }}
          <span class="italic">
            {{ lastEventAgo }}
          </span>
        </span>
      </div>
    </template>
  </UPopover>
</template>

<i18n lang="json">
{
  "en": {
    "allSocketsConnected": "Connected to live events",
    "connected": "Online",
    "lastEvent": "Last event received",
    "notConnected": "Offline"
  },
  "es": {
    "allSocketsConnected": "Conectado a eventos en directo",
    "connected": "Conectado",
    "lastEvent": "Último evento recibido",
    "notConnected": "Desconectado"
  },
  "fr": {
    "allSocketsConnected": "Connecté aux événements en direct",
    "connected": "Connecté",
    "lastEvent": "Dernier événement reçu",
    "notConnected": "Déconnecté"
  }
}
</i18n>
